import { Church } from "lucide-react";

interface ChurchInfoCardProps {
  name: string;
  city?: string | null;
  state?: string | null;
}

function formatLocation(
  city?: string | null,
  state?: string | null,
) {
  return [city, state].filter(Boolean).join(", ");
}

export function ChurchInfoCard({
  name,
  city,
  state,
}: ChurchInfoCardProps) {
  const location = formatLocation(city, state);

  return (
    <div className="rounded-2xl border border-slate-800 bg-slate-900/70 p-4">
      <div className="flex items-start gap-3">
        <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-indigo-500/10 text-indigo-400">
          <Church className="h-5 w-5" />
        </div>

        <div className="min-w-0">
          <p className="text-sm font-semibold leading-5 text-white">
            {name}
          </p>

          {location && (
            <p className="mt-1 text-sm text-slate-400">
              {location}
            </p>
          )}
        </div>
      </div>
    </div>
  );
}